import React from 'react';

const SolverActions = ({ 
  locations, 
  startId, 
  isSolving, 
  isLoadingAlgorithms, 
  selectedAlgorithm, 
  handleAlgorithmChange, 
  solvePath,
  getAlgorithmOptions
}) => {
  return (
    <div className="solver-actions">
      <button 
        className="solve-button"
        onClick={solvePath}
        disabled={locations.length < 2 || !startId || isSolving || isLoadingAlgorithms}
      >
        {isSolving ? 'Solving...' : 'Auto Solve'}
      </button>
      
      {/* Algorithm selector */}
      <div className="algorithm-selector">

        <select
          id="algorithm-select"
          className="algorithm-select"
          value={selectedAlgorithm}
          onChange={handleAlgorithmChange}
          disabled={isSolving || isLoadingAlgorithms}
        >
          {isLoadingAlgorithms ? (
            <option value="loading">Loading...</option>
          ) : (
            getAlgorithmOptions()
          )}
        </select>
      </div>
      
      {/* Start point hint */}
      {locations.length >= 2 && !startId && (
        <p className="start-point-hint">Please set a start point first to begin solving</p>
      )}
    </div>
  );
};

export default SolverActions; 